/* eslint-disable */
import { catFetchGet } from './base/catFetchClient';

export const copyLastWeekAsync = async () => {
    return await catFetchGet('weeklylog/copylastweek');
}